import { atom } from "jotai";

export function hasExternalCredentialsInUrl(): boolean {
  const params = new URLSearchParams(window.location.search);
  return (
    (!!params.get("origin") && !!params.get("productCategory")) ||
    !!params.get("sessionFromEasy")
  );
}

export const externalCredentialsHandoffAtom = atom(
  hasExternalCredentialsInUrl(),
);
